import { useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthScreenLayout from "../../../components/authScreenLayout/AuthScreenLayout";
import StatusAlertModel from "../../../components/statusAlertModel/StatusAlertModel";
import TextInfo from "../../../components/textInfo/TextInfo";
import TextInput, { EInputMode } from "../../../components/textInput/TextInput";
import {
  AUTH_ERROR,
  AUTH_LOADING,
  STOP_AUTH_LOADING,
} from "../../../const/actionTypes";
import { ILoginInput } from "../../../interfaces/loginInput";
import { ILoginResponse } from "../../../interfaces/loginResponse";
import { ISuccessState } from "../../../interfaces/successState";
import { IRootState } from "../../../store/configureStore";
import { login } from "../../../services/auth";
// @ts-ignore
import TncPdf from "../../../assets/pdf/tnc.pdf";
import { Box, Button, Typography } from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";

const Login = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { loading: isAuthLoading } = useSelector(({ auth }: IRootState) => ({
    loading: auth.loading,
  }));
  // Sync guard so Enter / double-click cannot fire two authenticate calls
  // before Redux loading flips (matches intermittent Invalid request token).
  const isSubmittingRef = useRef(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILoginInput>();

  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();
  // const [agreeTnc, setAgreeTnc] = useState<boolean>(false);
  const [isShowTnC, setIsShowTnc] = useState<boolean>(false);

  const onSubmit: SubmitHandler<ILoginInput> = (inputData) => {
    if (isSubmittingRef.current || isAuthLoading) {
      return;
    }
    isSubmittingRef.current = true;
    dispatch({ type: AUTH_LOADING });
    login(inputData)
      .then((data: ILoginResponse) => {
        if (data.userStatus === "FIRST-TIME-USER") {
          dispatch({ type: STOP_AUTH_LOADING });

          navigate("/verifyOtp", {
            state: {
              username: inputData.username,
              oldPassword: inputData.password,
              flow: "FIRST_TIME_LOGIN",
              request_token: data.request_token,
              otp_reference: data.otp_reference,
            },
          });
        } else {
          // dispatch({
          //   payload: data,
          //   type: SUCCESS_LOGIN,
          // });
          dispatch({ type: STOP_AUTH_LOADING });
          navigate("/verifyOtp", {
            state: {
              username: inputData.username,
              oldPassword: inputData.password,
              flow: "REGULAR_LOGIN",
              request_token: data.request_token,
              otp_reference: data.otp_reference,
            },
          });
        }
      })
      .catch(() => {
        setIsSuccess({
          isSuccess: false,
          message: "Please check your credentials and try again.",
        });
        dispatch({ type: AUTH_ERROR });
        isSubmittingRef.current = false;
      });
  };
  const guestInquiryHandler = () => {
    navigate("/guestInquiry");
  };

  const forgetPasswordHandler = () => {
    navigate("/forgetPassword");
  };
  const initTnCModal = () => {
    return setIsShowTnc(!isShowTnC);
  };

  return (
    <>
      <AuthScreenLayout>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontFamily: "sans-serif",
              color: "#1E4894",
              textAlign: "center",
              mb: "30px",
              // textDecoration: "underline",
            }}
          >
            Login
          </Typography>
          {/* <Typography
            variant="h6"
            sx={{
              fontWeight: "regular",
              fontFamily: "sans-serif",
              mb: "16px",
              color: "#333333",
              textAlign: "center",
              marginBottom: "16px",
            }}
          >
            Welcome Back
          </Typography> */}
          <TextInput
            placeholder="👤   Username (e-mail)"
            color="gray"
            className="mt-1"
            fontFamily="sans-serif"
            mode={EInputMode.light}
            useFormRegister={{
              ...register("username", {
                required: true,
                pattern:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              }),
            }}
            errors={[
              {
                isShow: errors.username?.type === "required",
                message: "Username is required",
              },
              {
                isShow: errors.username?.type === "pattern",
                message: "Email is invalid",
              },
            ]}
          />
          <TextInput
            placeholder="🔒   Password"
            color="gray"
            className="mt-3"
            type="password"
            fontFamily="sans-serif"
            mode={EInputMode.light}
            useFormRegister={{ ...register("password", { required: true }) }}
            errors={[
              {
                isShow: errors.password?.type === "required",
                message: "Password is required",
              },
            ]}
          />
          <TextInfo
            className="mt-3 mb-4 pointer"
            textAlign="right"
            fontFamily="sans-serif"
            color="gray"
            onClick={forgetPasswordHandler}
          >
            Forgot Password?
          </TextInfo>
          {/* <Row>
            <Col className="text-center mb-2">
              <CheckBox
                checked={agreeTnc}
                className="text-black"
                label={
                  <>
                    I agree to{" "}
                    <label
                      onClick={() => setIsShowTnc(true)}
                      className="text-primary text-underline"
                    >
                      <u>terms and conditions</u>
                    </label>
                  </>
                }
                style={{ color: "white", lineHeight: "2" }}
                onChange={(e) => {
                  setAgreeTnc(e.target.checked);
                }}
              />
            </Col>
          </Row> */}

          <Row>
            <Col
              className="text-center mb-3 mt-3 text-black"
              style={{ fontSize: 15 }}
            >
              {
                <>
                  By continue with the login button. I agree to the{" "}
                  <label
                    onClick={() => setIsShowTnc(true)}
                    className="text-primary text-underline"
                  >
                    <u>terms and conditions</u>
                  </label>
                </>
              }
            </Col>
          </Row>
          <Row className=" mb-4 mb-md-0">
            <Col>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  height: "100%",
                }}
              >
                <Button
                  type="submit"
                  disabled={isAuthLoading}
                  sx={{
                    background:
                      "linear-gradient(80deg, rgb(37, 127, 223), rgb(31, 75, 155))",
                    borderRadius: 30,
                    color: "white",
                    width: "300px",
                    height: "50px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: isAuthLoading ? 0.7 : 1,
                  }}
                  // disabled={!agreeTnc}
                >
                  {isAuthLoading ? "Please wait..." : "Login"}
                </Button>
              </Box>
            </Col>
            <Divider
              sx={{
                marginTop: "30px",
                marginBottom: "30px",
                backgroundColor: " rgb(31, 75, 155)",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            />
            <Col>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  height: "100%",
                }}
              >
                <Button
                  onClick={guestInquiryHandler}
                  sx={{
                    background: "#51B848",
                    borderRadius: 30,
                    color: "white",
                    width: "300px",
                    height: "50px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ":hover": {
                      background: "#5C725A",
                    },
                  }}
                >
                  Login as a Guest
                </Button>
              </Box>
            </Col>
          </Row>
        </form>
      </AuthScreenLayout>

      <Dialog
        open={isShowTnC}
        onClose={initTnCModal}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialogTitle-root": {
            backgroundColor: "#1e3a8a",
            color: "white",
            fontWeight: "600",
            fontSize: "1.5rem",
            padding: "20px 30px",
          },
          "& .MuiDialogContent-root": {
            padding: "30px",
            backgroundColor: "#f9fafb",
          },
          "& .MuiDialogActions-root": {
            padding: "16px 30px",
            justifyContent: "flex-end",
          },
        }}
      >
        <DialogTitle>Terms and Conditions</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <iframe
              title="Terms and Conditions"
              width="100%"
              height="100%"
              src={TncPdf}
              frameBorder="0"
              style={{
                border: "none",
                borderRadius: "20px",
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={initTnCModal}
            sx={{
              fontWeight: "bold",
              padding: "10px 20px",
              textTransform: "none",
              backgroundColor: "#3f51b5",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <StatusAlertModel isSuccess={isSuccess} setIsSuccess={setIsSuccess} />
    </>
  );
};

export default Login;
